export const LEVEL_SPARKLINE_MONTH_FORMAT = "MMM, YYYY";
